import { Text } from '@radix-ui/themes'
import * as React from 'react'

/* -------------------------------------------------------------------------------------------------
 * StringToComponent
 * -----------------------------------------------------------------------------------------------*/

type StringComponentProps = {
	className?: string
	children: React.ReactNode
	text: string
	start?: number
	needle?: string
}

const StringToComponent: React.FC<StringComponentProps> = ({
	className = '',
	children,
	needle = '{{val}}',
	start = 0,
	text,
}) => {
	return (
		<Text className={className}>
			<Text>{text.slice(start, text.indexOf(needle))}</Text>
			{children}
			<Text>{text.slice(text.indexOf(needle) + needle.length)}</Text>
		</Text>
	)
}
StringToComponent.displayName = 'StringToComponent'

/* -----------------------------------------------------------------------------------------------*/

export { StringToComponent, type StringComponentProps }
